import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';
import { find, get } from 'lodash';

import { ILoanAccountActivity } from '../../../interfaces';
import { OptionsStoreClass } from '../../../stores';
import { FormattingUtils } from '../../../utils';

import LoanAccountActivity from './LoanAccountActivity';

const { formatDate, formatMoney } = FormattingUtils;

interface IProps {
  activity: ILoanAccountActivity;
}

interface IInjected extends IProps {
  OptionsStore: OptionsStoreClass;
}

@inject('OptionsStore')
@autoBindMethods
@observer
class PaymentLogged extends Component<IProps> {
  private get injected () {
    return this.props as IInjected;
  }

  // The activity snapshots the payment type as a raw enum value; its label comes from the same
  // /options/ list the payment forms select from.
  private get paymentType () {
    const { payment_type } = this.props.activity.data
      , { OptionsStore } = this.injected
      , option = find(OptionsStore.loanPaymentTypeOptions, { value: payment_type })
      ;

    return get(option, 'name', payment_type);
  }

  public render () {
    const { data } = this.props.activity
      // The payment itself is not fetched: the feed renders the snapshot taken when it was logged,
      // so the entry still reads correctly if the payment is later changed.
      , activityBody = (
        <div>
          <h3>Payment Logged</h3>
          <p><span className='status'>Amount:</span> {formatMoney(data.amount)}</p>
          <p><span className='status'>Type:</span> {this.paymentType}</p>
          <p><span className='status'>Payment Date:</span> {formatDate(data.payment_date)}</p>
        </div>
      )
      ;

    // Passed explicitly rather than spread: a spread would let a prop added upstream override the
    // dot and icon this component picked, and the failure would be a wrong icon rather than an error.
    return (
      <LoanAccountActivity
        activity={this.props.activity}
        activity_body={activityBody}
        dot='icon'
        icon='usd'
      />
    );
  }
}

export default PaymentLogged;
